import { render } from "./BlogZircVenBenefits.vue?vue&type=template&id=7560c482"
import script from "./BlogZircVenBenefits.vue?vue&type=script&lang=js"
export * from "./BlogZircVenBenefits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__